import DiscoveryFooter from '@design/components/footer/discovery-footer/twig/assets'
import Newsletter from '@ui/Footer/Newsletter/component'

export default (el: HTMLElement) => {
  DiscoveryFooter(el)
  Newsletter(el)
}
